	import { Utils } from "@/plugins/utils";
	import router from '@/router';

	export default {
		namespaced: true,
		state: {
			lstPd2: [],
			pd2: null,
			insert: false,
			update: false,
			loading: false,
			itemsPerPage: 20,
			search: "",
			hasNext: false,
			pd2codigo: "",
			pd2tipoope: "",
			pd2tipo: "",
			pd2estadua: "",
			pd2contrib: "",
			pd2opercom: "",
			pd2emispro: "",
			pd2indpres: "",
		},
		getters: {
			
		},
		mutations: {
			set(state, pd2){
				state.pd2 = pd2
				if (pd2)
					state.update = true
			},
			initForm(state){
				state.insert = false
				state.update = false
				state.pd2 = null
			},
			setParamsDataTable(state, payload){
				state.lstPd2 = payload.items
				state.itemsPerPage = payload.limit
				state.hasNext = payload.hasNext
			},
		},
		actions: {
			initForm(store){
				store.commit("initForm")
			},
			async find(store, pd2codigo ){
				store.state.loading = true
				store.commit("initForm")
				await this._vm.$axios.get(`/OryxPdv/SalesOperationParameters/Find/${pd2codigo}`)
				.then(response => {
					let pd2 = Utils.ValidateAxiosResponse(response.data);
					pd2.pd2estadua = pd2.pd2estadua == 0 ? false : true
					store.commit("set", pd2)
				})
				.catch((error) => {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				});
				store.state.loading = false
			},
			save(store){
				store.state.pd2.pd2estadua = store.state.pd2.pd2estadua ? 1 : 0
				if (store.state.update){
					store.dispatch("update")
					return
				}
				store.dispatch("insert")
			},
			async insert(store){
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
				await this._vm.$axios.post("/OryxPdv/SalesOperationParameters/Insert", store.state.pd2 )
				.then(response => {
					Utils.ValidateAxiosResponse(response.data);
					router.push("/oryxpdv/parametros-operacoes-venda")
					store.state.pd2 = null
					return true
				})
				.catch((error) => {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			},
			async update(store){
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
				await this._vm.$axios.put("/OryxPdv/SalesOperationParameters/Update", store.state.pd2 )
				.then(response => {
					Utils.ValidateAxiosResponse(response.data);
					router.push("/oryxpdv/parametros-operacoes-venda")
					store.state.pd2 = null
					return true
				})
				.catch((error) => {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			},
			async delete(store){
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
				await this._vm.$axios.delete(`/OryxPdv/SalesOperationParameters/Delete/${store.state.pd2.pd2codigo}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data);
					router.push("/oryxpdv/parametros-operacoes-venda")
					return true
				})
				.catch((error) => {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			},
			async search(store, { limit = 20, page = 1}){
				store.state.loading = true
				let pd2contrib = ""
				let pd2emispro = ""

				if (store.state.pd2contrib != "" && store.state.pd2contrib != null)
					pd2contrib = Boolean(parseInt(store.state.pd2contrib))
				
				if (store.state.pd2emispro != "" && store.state.pd2emispro != null)
					pd2emispro = Boolean(parseInt(store.state.pd2emispro))
				
				store.commit("initForm")
				let payload = await this._vm.$axios.get(`/OryxPdv/SalesOperationParameters/Search?pd2codigo=${store.state.pd2codigo}&pd2tipoope=${store.state.pd2tipoope}&pd2tipo=${store.state.pd2tipo}&pd2estadua=${store.state.pd2estadua}&pd2contrib=${pd2contrib}&pd2opercom=${store.state.pd2opercom}&pd2emispro=${pd2emispro}&pd2indpres=${store.state.pd2indpres}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data);
					store.commit("setParamsDataTable", payload)
					return true
				})
				.catch((error) => {
					store.state.lstPd2 = []
					store.state.search = ""
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
				store.state.loading = false
				return payload
			},
		}
	}